export const EMPTY_IMAGE_SRC =
  'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

export const EMPTY_IMAGE = new Image(1, 1);
// 1x1 transparent pixel.
// For DnD:  If we use a 0x0 px image, Firefox will render the default drag image.
EMPTY_IMAGE.src = EMPTY_IMAGE_SRC;
